/**
 * A PDApp's deep link in the SPA — `/t/<tenant>/app/<ref>/<page>?<query>#<hash>` —
 * as BOTH shells read it, so the address `pdapp.links.page()` builds inside Papan
 * opens the same page, with the app's own query and hash, on a desktop and a phone.
 */
import { appOwnUrlSuffix } from '@papan/types'

/** The desktop shell's app routes (App.tsx). `/*` is the page under the app. */
export const DESKTOP_APP_ROUTE_PATHS = ['/~/app/:fileId/*', '/t/:tenant/app/:fileId/*', '/~/app/:fileId', '/t/:tenant/app/:fileId'] as const

/** The phone shell's app routes (MobileShell.tsx) — the desktop shapes, plus bare `/app`. */
export const MOBILE_APP_ROUTE_PATHS = ['/app/:fileId', '/~/app/:fileId', '/t/:tenant/app/:fileId', '/app/:fileId/*', '/~/app/:fileId/*', '/t/:tenant/app/:fileId/*'] as const

/**
 * The first page an app window opens for this location: `initialPath` the page under
 * the app (decoded; a raw `%` from an old saved URL is kept as written), `initialSuffix`
 * the app's OWN `?query#hash` (Papan's own params dropped). Both undefined when absent.
 */
export function appDeepLinkEntry(loc: { pathname: string; search?: string; hash?: string } | null | undefined): { initialPath?: string; initialSuffix?: string } {
  if (!loc) return {}
  const splat = loc.pathname.match(/\/app\/[^/]+\/(.+)$/)?.[1]
  let initialPath: string | undefined
  if (splat) { try { initialPath = decodeURIComponent(splat) } catch { initialPath = splat } }
  const initialSuffix = appOwnUrlSuffix(loc.search, loc.hash) || undefined
  return { initialPath, initialSuffix }
}
